/* global __webpack_modules__ */

import { appDefault } from '../config/config';
import {
  numberPrecision,
  getPrecision,
  commatize,
} from '../util/util';

/**
 * Formats data point values according to the column settings and/or
 * primitive parsing conditionals
 */
if (__webpack_modules__[require.resolveWeak('angular')]) {
  filterSwitch.$inject = ['$filter'];
}
export default function filterSwitch($filter) {
  if (!__webpack_modules__[require.resolveWeak('angular')]) {
    /* eslint-disable no-param-reassign */
    $filter = (filter) => {
      return {
        currency: (i, sym, precision) =>
          commatize((+numberPrecision(i, precision, false)), sym),
        percent: (i) => `${i}%`,
        number: (number, precision) => {
          // Taken from 'formatNumber' in angular.js
          let fraction = ('' + number).split('.');
          let formattedText = fraction[0];
          fraction = fraction[1] || '';

          // Format fraction
          fraction = `${fraction}${
            [...Array(precision - fraction.length)].map(() => '0').join('')
          }`;

          if (precision && precision !== '0') {
            formattedText += '.' + fraction.substr(0, precision);
          }

          return commatize(formattedText);
        },
      }[filter];
    };
    /* eslint-enable no-param-reassign */
  }

  return function(value, column) {
    const precision = getPrecision(column);
    const valueIsString = typeof value === 'string';
    const prefixChar = valueIsString ? value.charAt(0) : '';
    const isPrefixed = ['<', '>'].indexOf(prefixChar) > -1;
    // These are blank cells. Leave them blank
    if ((!value && isNaN(value)) ||
        typeof value === undefined ||
        typeof value === 'boolean' ||
        value === null
    ) {
      return '';
    // If it has a pipe, just return it
    } else if (value.toString().indexOf('|') > -1) {
      return value;
    // Format special < or > Currency numbers
    } else if (column.type.indexOf('currency') > -1 &&
      valueIsString && isPrefixed) {
      return prefixChar + $filter('currency')(
        value.substring(1), '$', precision
      );
    // Format special < or > Percent numbers
    } else if (/^percent/.test(column.type) &&
      valueIsString && isPrefixed) {
      return prefixChar + $filter('percent')(
        (
          +numberPrecision(value.substring(1), precision, true)
        ).toFixed(precision)
      );
    // Format special < or > Regular numbers
    } else if (/^number/.test(column.type) &&
      valueIsString && isPrefixed) {
      return prefixChar + $filter('number')(
        numberPrecision(value.substring(1), precision), precision
      );
    // If datatype is defined, but doesn't need to be formatted
    } else if (column.type === 'geography' ||
        column.type === 'text' ||
        column.type === 'year' ||
        appDefault.dataNotAvailable.indexOf(value) > -1 ||
        isNaN(value)) {
      return value;
    // Percent types with possible args
    } else if (/^percent/.test(column.type)) {
      // @TODO replace with built in filter
      return $filter('percent')(
        (+numberPrecision(value, precision, true)).toFixed(precision)
      );
    // Currency types with possible args
    } else if (/^currency/.test(column.type)) {
      return $filter('currency')(value, '$', precision);
    }

    let number = $filter('number')(
      numberPrecision(value, precision), precision
    );
    if (column.Prefix) {
      number = column.Prefix + number;
    }
    if (column.Suffix) {
      number = number + column.Suffix;
    }
    if (number[number.length - 1] === '.') {
      number = number.slice(0, -1);
    }
    return number;
  };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/filters/switchFilter.js
 **/